const actions = {
  MY_MENU_SURVEY_REQUEST: "MY_MENU_SURVEY_REQUEST",
  MY_MENU_SURVEY_SUCCESS: "MY_MENU_SURVEY_SUCCESS",

  getMyMenuSurvey: (startDate, endDate, selectedRestaurant) => {
    return (dispatch) => {
      dispatch({
        type: actions.MY_MENU_SURVEY_REQUEST,
        startDate,
        endDate,
        selectedRestaurant,
      });
    };
  },
};
export default actions;
